import React from 'react';
import { View } from 'react-native';

import { ViewPropTypes } from 'deprecated-react-native-prop-types';
import { map as _map } from 'lodash';
import PropTypes from 'prop-types';

import { useTheme } from '@vfgroup-oneplatform/foundation/Components/Themes';
import MyPlanInfoItem from '@vfgroup-oneplatform/framework/MyPlan/Components/MyPlanInfoItem';

import SohoFrameworkTestKeys from '../../../../Utils/SohoFrameworkTestKeys';

import styles from './PlanContractInfo.Styles';

function PlanContractInfo({
  contractData,
  containerStyle,
  labelAccessibilityLabel,
  valueAccessibilityLabel,
  isShowMoreContractData,
  ...props
}) {
  const theme = useTheme();
  const contractsLength = contractData?.length;
  return (
    <View style={[styles.containerStyle, containerStyle]}>
      {_map(contractData, (item, index) => {
        const { key, value } = item;

        return (
          <MyPlanInfoItem
            key={index}
            label={key}
            value={value}
            containerStyle={[
              styles.infoItemContainerStyle(index !== contractsLength - 1, theme),
              isShowMoreContractData && index === 0 ? styles.infoItemTopStyle(theme) : null,
            ]}
            labelAccessibilityLabel={
              labelAccessibilityLabel ??
              SohoFrameworkTestKeys.PlanTitlePart +
                index +
                SohoFrameworkTestKeys.PlanSecondPartTitle
            }
            valueAccessibilityLabel={
              valueAccessibilityLabel ??
              SohoFrameworkTestKeys.PlanTitlePart +
                index +
                SohoFrameworkTestKeys.PlanSecondPartValue
            }
          />
        );
      })}
    </View>
  );
}

PlanContractInfo.propTypes = {
  contractData: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string,
      value: PropTypes.string,
      type: PropTypes.string,
    }),
  ),
  containerStyle: ViewPropTypes.style,
  isShowMoreContractData: PropTypes.bool,
  labelAccessibilityLabel: PropTypes.string,
  valueAccessibilityLabel: PropTypes.string,
};

export default PlanContractInfo;
